// Illustrations générées (afro-descendantes) par univers.
export const ILLUSTRATIONS = {
  childHero: "https://static.prod-images.emergentagent.com/jobs/2f4d011d-def7-4d5a-b586-dd00b3a6eeb7/images/4b99f3e4f6de0d1d9092cd2cfe182f5aff31e396f57936e22652d58eb106b5a8.jpeg",
  robotMascot: "https://static.prod-images.emergentagent.com/jobs/2f4d011d-def7-4d5a-b586-dd00b3a6eeb7/images/7ecfbfebeaeaef58c809ea265a30e6d6a5300344e32f90dc72370d2e742a89e0.jpeg",
  teenHero: "https://static.prod-images.emergentagent.com/jobs/2f4d011d-def7-4d5a-b586-dd00b3a6eeb7/images/94bcc93086247b095ab56cfef00c7eb625d4fdbea64509e00340f4bc868fc6bb.jpeg",
  parentHero: "https://static.prod-images.emergentagent.com/jobs/2f4d011d-def7-4d5a-b586-dd00b3a6eeb7/images/12d111634a6f8512eba27febc17d69c543f69eebca5abc189a21f8d8bd94f217.jpeg",
};

export const IS_THEMED = (p) => p === "child" || p === "teen" || p === "parent";

// Prénom de l'enfant — FACULTATIF, stocké localement (aucune donnée envoyée).
const CHILD_NAME_KEY = "bizarre_child_name";
export const getChildName = () => {
  try { return (localStorage.getItem(CHILD_NAME_KEY) || "").trim(); } catch (_) { return ""; }
};
export const setChildName = (name) => {
  try { localStorage.setItem(CHILD_NAME_KEY, (name || "").trim()); } catch (_) { /* noop */ }
};
